import FleetManager from "./FleetManager";

function App() {
  return <FleetManager />;
}

export default App;